import React, { useState, useRef, useEffect } from "react";
import "./configureAsset.css";
import { Button, Grid } from "@mui/material";
import ButtonPolicy from "src/components/Permission/ButtonPolicy";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { convertToBase64 } from "src/util/utilFunctions";
import { base64Suffix } from "src/util/utilFunctions";
import { updateAssetImg, deleteCoordinate } from "src/apis/ConfigureAsset3d";
import { useAlertContext } from "src/hooks/use-alert";
import DeleteIcon from '@mui/icons-material/Delete';
/**
 * @param {configurationDataWithImage} assetImg data that  was loaded 
 * @param {configurationData}  aseet data in the parent page 
 * @param {openDialog} state to open dialog
 * @param {closeDialog} wrapper function to close dialog
 * 
 */
const UpdateImageForm = ({ configurationDataWithImage,configurationData,openDialog,closeDialog }) => {
  const alert = useAlertContext();
  const [image, setImage] = useState( base64Suffix.concat(configurationDataWithImage.image));
  {/**only retain fields needed for update in sensorData */}
  const [sensorData, setSensorData] = useState(configurationDataWithImage.coordinateDto.map(item => ({
    id:item.id,
    itemId: item.itemId,
    xpoint: item.xpoint,
    ypoint: item.ypoint,
    itemIsAlarm:item.itemIsAlarm
  })));
  
  const [automaticMode, setAutomaticMode] = useState(false);
  const [imageUploaded, setImageUploaded] = useState(false);
  const [showClickHint, setShowClickHint] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [imageInBytes, setImageInBytes] = useState(configurationDataWithImage.image);
  const [apiBody,setApiBody]=useState(null);
  const handleUpdateConfiguration = async (body) => {
    console.log("api body : ",body)
    if (body) {
      const response = await updateAssetImg(body);
      if (response.success) {
        alert.setSuccess((prev) => [
          ...prev,
          {
            status: true,
            message: "Asset Image and coordinates Succesful",
            index: prev.length,
          },
        ]);
        const closeForm=false //declaration for leggibility
        const  updateVisualizeAssetComp=true //declaration for leggibility
        closeDialog(closeForm,updateVisualizeAssetComp);
           } else {
        alert.setError((prev) => [
          ...prev,
          { status: true, messages: response.errors, index: prev.length },
        ]);
      }
    }
  };

  const saveImageInState = (base64Image,imgtype) => {
    const imageWithoutSuffix = base64Image.replace(new RegExp(`data:${imgtype};base64,`), "");
    setImageInBytes(imageWithoutSuffix);
  };

  const handleItemSelected = (event) => {
    setSelectedItem(event.target.value);
  };

  const imageRef = useRef(null);

  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = () => {
      setImage(reader.result);
      setImageUploaded(true);
    };
    if (file) {
      const filetype=file.type
      reader.readAsDataURL(file);
      convertToBase64(file, saveImageInState,filetype);
    }
  };

  const handleAutomaticMode = () => {
    setAutomaticMode(!automaticMode);
    if (!automaticMode) {
      setShowClickHint(true);
    } else {
      setShowClickHint(false);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log(sensorData);
  };

  const handleInputChange = (index, key, value) => {
    const updatedSensorData = [...sensorData];
    updatedSensorData[index][key] = value;
    setSensorData(updatedSensorData);
  };
  const handleDeleteRow = async (index) => {
    const confirmDelete = window.confirm('Are you sure you want to delete this coordinate?');
    if (confirmDelete) {
      try {
        const deletedCoordinate = await deleteCoordinate(sensorData[index].id);
        if (deletedCoordinate) {
          const updatedSensorData = sensorData.filter((_, i) => i !== index);
          setSensorData(updatedSensorData);
          alert.setSuccess((prev) => [
            ...prev,
            {
              status: true,
              message: "Coordinate deleted successfully",
              index: prev.length,
            },
          ]);
        } else {
          alert.setError((prev) => [
            ...prev,
            { status: true, messages: "Failed to delete coordinate", index: prev.length },
          ]);
        }
      } catch (error) {
        console.error("Error deleting coordinate:", error);
        alert.setError((prev) => [
          ...prev,
          { status: true, messages: "Failed to delete coordinate", index: prev.length },
        ]);
      }
    }
  };

  useEffect(() => {
    const handleAddLabel = (xpoint, ypoint) => {
      setSensorData([
        ...sensorData,
        { xpoint: xpoint, ypoint: ypoint, itemId: selectedItem },
      ]);
    };
    const handleImageClick = (event) => {
      if (automaticMode && imageRef.current) {
        const rect = imageRef.current.getBoundingClientRect();
        let xpoint = ((event.clientX - rect.left) / rect.width) * 100;
        let ypoint = ((event.clientY - rect.top) / rect.height) * 100;

        xpoint = parseFloat(xpoint.toFixed(2));
        ypoint = parseFloat(ypoint.toFixed(2));

        handleAddLabel(xpoint, ypoint);
      }
    };

    let currentImageRef = imageRef.current;

    if (automaticMode && currentImageRef) {
      currentImageRef.addEventListener("click", handleImageClick);
    }

    return () => {
      if (currentImageRef) {
        currentImageRef.removeEventListener("click", handleImageClick);
      }
    };
  }, [automaticMode, imageRef, sensorData, selectedItem]);

  useEffect(() => {
    if (imageInBytes) {
      var visualizer = {
        assetId: configurationData.id,
        assetImgId: configurationDataWithImage.id,
        coordinates: sensorData,
        image: imageInBytes,
      };
    }
    if(visualizer){
      console.log("api body for update : ", visualizer)
    setApiBody(visualizer);}
  }, [sensorData, imageInBytes]);

  return (
    <>
    <Dialog open={openDialog}  onClose={closeDialog} fullScreen>
    <div className="modalContainer">
      <div className="modal">
        <DialogContent>
    <div className="image-form-container">
      <Grid container>
        <Grid md={6} sm={12} lg={6} xs={12}>
          <div className="wrapper">
            <form onSubmit={handleSubmit} className="labelForm">
              <Grid container>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <div className="imageInput">
                    <label htmlFor="image">Choose an Image:</label>
                    <input
                      type="file"
                      accept="image/*"
                      id="image"
                      onChange={handleImageUpload}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  {image && (
                    <div className="buttonWrapper">
                      <ButtonPolicy onClick={handleAutomaticMode}>
                        {automaticMode ? "Disable Labeling" : "Enable Labeling"}
                      </ButtonPolicy>
                    </div>
                  )}
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  {automaticMode && showClickHint && (
                    <p className="hint">
                      Hint: Click on the point on the image where you want to
                      add a label, and the x and y coordinates will be
                      automatically generated.
                    </p>
                  )}
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  {sensorData.map((sensor, index) => (
                    <div key={index} className="inputWrapper">
                      <div className="firstPart">
                        <label htmlFor={`x-${index}`}>X:</label>
                        <input
                          type="text"
                          id={`x-${index}`}
                          value={sensor.xpoint}
                          onChange={(e) =>
                            handleInputChange(index, "xpoint", e.target.value)
                          }
                        />
                        <label htmlFor={`y-${index}`}>Y:</label>
                        <input
                          type="text"
                          id={`y-${index}`}
                          value={sensor.ypoint}
                          onChange={(e) =>
                            handleInputChange(index, "ypoint", e.target.value)
                          }
                        />
                      </div>
                      <div className="secondPart">
                        <label htmlFor={`label-${index}`}>Item:</label>
                        <select
                          value={sensor.itemId}
                          onChange={(e) =>
                            handleInputChange(index, "itemId", parseInt(e.target.value))
                          }
                        >
                          <option value="">{
                        configurationData.items.find(
                          (item) => item.id === parseInt(sensor.itemId)
                        )?.serialNumber
                      }</option>
                          {configurationData.items.map((item) => (
                            <option key={item.serialNumber} value={item.id}>
                              {item.serialNumber}
                            </option>
                          ))}
                        </select>
                        <Button onClick={() => handleDeleteRow(index)}>
                          <DeleteIcon/>
                        </Button>
                      </div>
                    </div>
                  ))}
                </Grid>
              </Grid>
            </form>
          </div>
        </Grid>
        <Grid md={6} sm={12} xs={12} lg={6}>
          <div className="ImagePreviewWrapper">
            {!imageUploaded && (
              <div className="image-preview">
                <div>Image Preview</div>
              </div>
            )}

            {image && (
              <div className="image-preview" style={{ position: "relative" }}>
                <img
                  ref={imageRef}
                  src={image}
                  alt="Uploaded"
                  style={{ width: "100%", height: "100%" }}
                />
                {sensorData.map((sensor, index) => (
                  <div
                    key={index}
                    className="dot"
                    style={{
                      position: "absolute",
                      left: sensor.xpoint + "%",
                      top: sensor.ypoint + "%",
                    }}
                  >
                    <div className="labels">
                      {
                        configurationData.items.find(
                          (item) => item.id === parseInt(sensor.itemId)
                        )?.serialNumber
                      }
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className="buttonWrapper">
          <ButtonPolicy
              type="button"
             
              onClick={()=> handleUpdateConfiguration(apiBody)}
             
            >
              Update
            </ButtonPolicy>
            </div>
        </Grid>
      </Grid>
    </div>
    </DialogContent>
    </div>
    </div>
    </Dialog>
    </>
  );
};

export default UpdateImageForm;
